import { Heading, Text } from 'ui-kit/typography'
import { DifferenceTable } from 'routes/HowWeAreDifferent/components/Table/DifferenceTable'
import { DifferencePointDataType } from './pointData'
import clsx from 'clsx'
import classes from './DifferencePoint.module.scss'

export const DifferencePointCard = ({
  item,
}: {
  item: DifferencePointDataType
}) => {
  const { icon, alt, caption, name, description, border, status } = item

  return (
    <li
      className={clsx(
        'flex-column',
        classes.item,
        classes.border,
        classes[border],
      )}
    >
      <div className={clsx('flex-column', classes.header)}>
        <div className={classes.holder}>
          <img
            src={icon.src}
            alt={alt}
            width={40}
            height={40}
            loading='lazy'
            className={classes.icon}
          />
          <div>
            <Text as={'span'} size={'sm'} className={classes.caption}>
              {caption}
            </Text>
            <Heading as={'h4'} size={'xs'} lh={'tight'}>
              {name}
            </Heading>
          </div>
        </div>
        <Text size={'sm'} className={classes.description}>
          {description}
        </Text>
      </div>
      <div className={classes.data}>
        <DifferenceTable status={status} />
      </div>
    </li>
  )
}
